import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { PieChart } from '@mui/x-charts/PieChart';
import CustomLegend from '../../CustomLegend';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { getChartColor } from './widgetData';

const BreakdownWidget = ({ widget, metric }) => {
  const buckets = metric?.value && typeof metric.value === 'object' ? metric.value : null;
  const chartType = widget.params?.chart || 'donut';
  const showLegend = Boolean(widget.params?.showLegend);

  if (!buckets || Object.keys(buckets).length === 0) {
    return (
      <WidgetCard
        title={widget.params?.title || 'Breakdown'}
        subtitle={widget.params?.metricId}
        testId={`report-widget-${widget.id || widget.params?.metricId || 'breakdown'}`}
      >
        <WidgetEmptyState message="Breakdown data is not available yet." />
      </WidgetCard>
    );
  }

  const entries = Object.entries(buckets);
  const data = entries.map(([label, value], index) => ({
    id: index,
    label,
    value,
    color: getChartColor(index),
  }));

  return (
    <WidgetCard
      title={widget.params?.title || 'Breakdown'}
      subtitle={widget.params?.metricId}
      testId={`report-widget-${widget.id || widget.params?.metricId || 'breakdown'}`}
    >
      {chartType === 'bar' ? (
        <BarChart
          height={220}
          xAxis={[{ data: data.map((item) => item.label), scaleType: 'band' }]}
          series={[{ data: data.map((item) => item.value) }]}
          colors={data.map((item) => item.color)}
        />
      ) : (
        <PieChart
          height={220}
          series={[
            {
              data,
              innerRadius: chartType === 'pie' ? 0 : 40,
              outerRadius: 90,
            },
          ]}
          legend={{ hidden: true }}
        />
      )}
      {showLegend && <CustomLegend data={data} />}
    </WidgetCard>
  );
};

export default BreakdownWidget;
